import { MovieClip, Sprite } from "../runtime";
import { SPR_rain } from "./assets";

/**
 * Scrolling rain overlay: one oversized 128px-tiled fill that is repositioned
 * every frame so the tiling wraps. `update` follows the level camera, while
 * `updateIntro` is the cutscene variant that also ramps the alpha in and, once
 * `kill` is called, back out.
 */
export class Rain extends MovieClip {
  private readonly fallSpeedX = 8;
  private readonly fallSpeedY = 16;
  private alphaCurrent = 0;
  private fading = false;
  private fallPosX = 0;
  private fallPosY = 0;

  constructor(intro = false) {
    super();
    const rainSpr = new Sprite();
    rainSpr.graphics.beginBitmapFill(new SPR_rain());
    rainSpr.graphics.drawRect(-128, -128, 720 + 128, 480 + 128);
    rainSpr.graphics.endFill();
    this.addChild(rainSpr);
    if (intro) {
      this.alpha = 0;
    }
  }

  /** True once a killed cutscene overlay has faded all the way out. */
  updateIntro(): boolean {
    let faded = false;
    if (!this.fading) {
      if (this.alphaCurrent < 100) {
        ++this.alphaCurrent;
        this.alpha = this.alphaCurrent * 0.01;
      }
    } else if (this.alphaCurrent > 0) {
      --this.alphaCurrent;
      this.alpha = this.alphaCurrent * 0.01;
      if (this.alphaCurrent === 0) {
        faded = true;
      }
    }
    // the cutscene overlay wraps off its own position, and only on one side
    let xPos = this.x - this.fallSpeedX;
    let yPos = this.y + this.fallSpeedY;
    if (xPos <= 0) {
      xPos += 128;
    }
    if (yPos >= 128) {
      yPos -= 128;
    }
    this.x = xPos;
    this.y = yPos;
    return faded;
  }

  update(offsetX = 0, offsetY = 0): void {
    this.fallPosX -= this.fallSpeedX;
    this.fallPosY += this.fallSpeedY;
    if (this.fallPosX <= -128) {
      this.fallPosX += 128;
    }
    if (this.fallPosY >= 128) {
      this.fallPosY -= 128;
    }
    let xPos = offsetX + this.fallPosX;
    let yPos = offsetY + this.fallPosY;
    if (xPos <= -128) {
      xPos += Math.ceil(xPos / -128) * 128;
    }
    if (xPos >= 128) {
      xPos -= Math.ceil(xPos / 128) * 128;
    }
    if (yPos <= -128) {
      yPos += Math.ceil(yPos / -128) * 128;
    }
    if (yPos >= 128) {
      yPos -= Math.ceil(yPos / 128) * 128;
    }
    this.x = xPos;
    this.y = yPos;
  }

  /** Starts the cutscene overlay's fade-out. */
  kill(): void {
    this.fading = true;
  }
}
